import { useMutation } from "@tanstack/react-query";
import { LucideLoader2, LucideWandSparkles } from "lucide-react";
import { generateAiOptimizedDescriptionForReviewRequest } from "@/lib/client/review";
import { Button } from "@/components/ui/button";

export function AiOptimizeDescription({ id, onSuccess }: { id: string; onSuccess: () => void }) {
  const { mutate, isPending } = useMutation({
    mutationFn: generateAiOptimizedDescriptionForReviewRequest,
    onSuccess,
  });
  return (
    <Button
      size="sm"
      variant="outline"
      className="shadow-md"
      disabled={isPending}
      onClick={() => mutate({ data: { id } })}
    >
      {isPending ? <LucideLoader2 className="animate-spin" /> : <LucideWandSparkles />}
      使用AI优化表达
    </Button>
  );
}
